import Input            from '@widesk-ui/components/form/Input';
import { InputProps }   from '@widesk-ui/components/form/Input';
import { LinkOutlined } from '@ant-design/icons';
import { Rule }         from 'antd/lib/form';
import './InputUrl.scss';

export const InputUrl = (props: InputProps) => {
	return (
		<Input
			allowClear
			className="widesk-url-input"
			addonBefore={!props.value?.includes('https://') && 'https://'}
			addonAfter={props.value ? <a href={props.value} target="_blank"><LinkOutlined /></a> : <LinkOutlined />}
			type="url"
			minLength={8}
			{...props}
			onChange={(e: any) => {
				let value = e.target.value.toString() as string;
				if (value && value.length >= 8 && !value.includes('https://')) {
					value = 'https://' + value;
				}

				props?.onChange?.(value);
			}}
		/>
	);
};

InputUrl.rules = [{ type: 'url', message: `La valeur n'est pas un lien correct` }] as Rule[];

InputUrl.formFieldAttributes = {
	element: <InputUrl placeholder="Entrez une url" />,
	rules: InputUrl.rules,
};

export default InputUrl;
